import { ASSETS } from "@/data/landingData";
import { useLanguage } from "@/context/LanguageContext";

const HighlightsSection = () => {
  const { copy } = useLanguage();

  return (
    <section className="section" id="avantages" data-testid="highlights-section">
      <div className="container" data-testid="highlights-container">
        <div className="section-header">
          <p className="section-kicker" data-testid="highlights-kicker">
            {copy.highlights.kicker}
          </p>
          <h2 className="section-title" data-testid="highlights-title">
            {copy.highlights.title}
          </h2>
        </div>
        <div className="highlight-grid" data-testid="highlight-grid">
          <div className="highlight-list" data-testid="highlight-list">
            <ul data-testid="highlight-items">
              {copy.highlights.items.map((item, index) => (
                <li key={item} data-testid={`highlight-item-${index}`}>
                  {item}
                </li>
              ))}
            </ul>
            <p className="highlight-note" data-testid="highlight-note">
              {copy.highlights.note}
            </p>
            <a
              className="secondary-button"
              href={ASSETS.pumpCatalog}
              target="_blank"
              rel="noreferrer"
              data-testid="catalog-link-button"
            >
              {copy.highlights.button}
            </a>
          </div>
          <div className="highlight-media" data-testid="highlight-media">
            <img
              src={ASSETS.irrigationBox}
              alt={copy.highlights.imageAlt}
              loading="lazy"
              data-testid="highlight-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HighlightsSection;